"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgCrossFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm1.005 4.005h-1.993c-.261 0-.48.08-.66.238a1.121 1.121 0 00-.352.586V10H7c-.289 0-.528.1-.719.303a.966.966 0 00-.28.697v2a.954.954 0 00.28.694A.948.948 0 007 14h3v2.998c0 .242.095.47.284.683.19.213.428.319.715.319H13a.914.914 0 00.728-.32c.184-.212.274-.437.272-.675V14h3c.288 0 .529-.102.722-.306A.941.941 0 0018 13v-2a.97.97 0 00-.278-.697A1 1 0 0017 10h-3V6.843c-.077-.27-.192-.47-.347-.6-.154-.13-.37-.21-.648-.238z' }))); };
exports.default = SvgCrossFilled;
//# sourceMappingURL=CrossFilled.js.map